import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { hypothesis } from '../register-hypothesis-ras.component';

@Component({
  selector: 'hypothesis-form-ras',
  templateUrl: './hypothesis-form-ras.component.html',
  styleUrls: ['./hypothesis-form-ras.component.scss'],
})
export class HypothesisFormRasComponent implements OnInit {
  constructor(private readonly fb: FormBuilder) {}

  @Input() hypothesis: hypothesis[];

  @Output() hypothesisChange = new EventEmitter<hypothesis[]>();

  form = this.fb.group({
    hypothesis: ['', [Validators.required]],
  });

  get isEditing() {
    return this.editingId !== null;
  }

  editingId = null;

  ngOnInit() {}

  add() {
    const value = this.form.value.hypothesis;

    if (this.isEditing) {
      const index = this.hypothesis.findIndex(
        (item) => item.id === this.editingId
      );
      this.hypothesis[index].hypothesis = value;
      this.editingId = null;
    } else {
      let item = {
        hypothesis: value,
        id: this.hypothesis.length,
      };
      this.hypothesis.push(item);
    }

    this.form.reset();
    this.setValues();
  }

  @Output() changeValues = new EventEmitter();

  cancelEdit() {
    this.editingId = null;
    this.form.reset();
  }

  setValues() {
    this.hypothesisChange.emit(this.hypothesis);
    this.changeValues.emit();
  }
}
